// src/features/products/userAuthApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Urls from "../../components/Url/Urls";


export const signInUserApi = createApi({
  reducerPath: 'signInUserApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.user.get }),
  tagTypes: ['signInUserApi'],
  endpoints: (builder) => ({
    signInUser: builder.mutation({
      query: (auth) => {
        return {
          url: Urls.user.post,
          method: 'POST',
          body: auth,
        
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['userAuthApi'], 
    }),
  }),
  keepUnusedDataFor: 1,

});




export const signInCheckUserApi = createApi({
  reducerPath: 'signInCheckUserApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.user.get }),
  tagTypes: ['signInCheckUserApi'],
  endpoints: (builder) => ({
    signInCheckUser: builder.mutation({
      query: (auth) => {
       
        return {
          url: Urls.user.signinchecker,
          method: 'POST',
          body: auth,
         
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['signInCheckUserApi'], 
    }),
  }),
  keepUnusedDataFor: 1,

});




export const {
 useSignInUserMutation
} = signInUserApi;



export const {
  useSignInCheckUserMutation
 } = signInCheckUserApi;
 
 

export const signUpUserApi = createApi({
  reducerPath: 'signUpUserApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.user.get }),
  tagTypes: ['signUpUserApi'],
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => "getUsers",
      keepUnusedDataFor: 35,
      providesTags: ['signUpUserApi'],
      invalidatesTags: ['signUpUserApi'],
    }),
    signUpUser: builder.mutation({
      query: (auth) => {
       
        return {
          url: Urls.user.create,
          method: 'POST',
          body: auth,
         
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['signUpUserApi'], 
    }),


    updateUser: builder.mutation({
      query: (dataUser) => {
       
        return {
          url: Urls.user.update+dataUser.id,
          method: 'PUT',
          body: dataUser,
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['signUpUserApi'], 
    }),  
  }),
 
  keepUnusedDataFor: 1,

});



export const saveUserRoleApi = createApi({
  reducerPath: 'saveUserRoleApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.roles.get }),
  tagTypes: ['saveUserRoleApi'],
  endpoints: (builder) => ({
    addUserToRoles: builder.mutation({
      query: (auth) => {
        return {
          url: Urls.roles.post,
          method: 'POST',
          body: auth,
         
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['saveUserRoleApi'], 
    }),
  }),
  keepUnusedDataFor: 1,
});


// get User drop down
export const userDropDownApi = createApi({
  reducerPath: "userDropDownApi",
  baseQuery: fetchBaseQuery({ baseUrl:Urls.user.dropdown}),
  tagTypes: ["userDropDownApi"],
  keepUnusedDataFor: 30,
  endpoints: (builder) => ({
    GetDropDownUsers: builder.query({
      query: () => `/getDropDownUsers`,
      keepUnusedDataFor: 5,
      providesTags: ["userDropDownApi"],
     
    }),
   
  }),
});



export const UserRolesApi = createApi({
  reducerPath: "UserRolesApi",
  baseQuery: fetchBaseQuery({ baseUrl: Urls.roles.get}),
  tagTypes: ["UserRolesApi"],
  keepUnusedDataFor: 30,
  endpoints: (builder) => ({
    GetUserRoles: builder.query({
      query: (id) => `/`+id,
      keepUnusedDataFor: 5,
      providesTags: ["UserRolesApi"],
    }),
  }),
});



export const updateUserRoleApi = createApi({
  reducerPath: "updateUserRoleApi",
  baseQuery: fetchBaseQuery({ baseUrl:Urls.roles.get}),
  tagTypes: ["updateUserRoleApi"],
  keepUnusedDataFor: 30,
  endpoints: (builder) => ({
    updateUserRole: builder.mutation({
      query: (updatedData) => ({
        url: Urls.roles.update+`/`+updatedData.Id,
        method: "PUT",
        body: updatedData,
      }),
      keepUnusedDataFor: 5,
      transformResponse: (response, meta, arg) => {
       return response
     },
      invalidatesTags: ["updateUserRoleApi"],
    }),
  }),
});






export const {
  useAddUserToRolesMutation
} = saveUserRoleApi;



export const {
  useUpdateUserRoleMutation
} = updateUserRoleApi;


export const {
  useGetUserRolesQuery
} = UserRolesApi;


export const {
  useGetDropDownUsersQuery
} = userDropDownApi;



export const {
 useSignUpUserMutation,
 useGetUsersQuery,
 useUpdateUserMutation
} = signUpUserApi;
